// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6944) return "static/chunks/6944-d6d84e3d4b254d26.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1020":"1f663a175e0fade7","5019":"23a80bf967361a5c","7974":"a0b00663586e1621","8810":"d9c8091e2f719f81","8839":"8170f79049ea9dd8","9076":"581f713d9655ab63"}[chunkId] + ".js";
};